



















































































































































































































































































import { getAllAppFields } from '@/api/admin'
import { AppStepSectionDTO } from '@/api/types-app'
import { defineComponent, ref, watch, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    appSteps: {
      type: Array,
      required: false,
      default: Object as () => Array<AppStepSectionDTO>
    }
  },
  name: 'AppStep',
  emits: ['update:modelValue'],
  setup(props, { attrs }) {
    const modelValue = ref<AppStepSectionDTO>((attrs['v-model'] as AppStepSectionDTO))
    const allAppFields = ref()
    const activePage = ref(null)
    const activeField = ref(null)
    const fields = ref(null)
    const pages = ref(null)
    const initialFieldModal = ref(false)
    const addFieldModal = ref(false)
    const initialAppField = ref(null)
    const newAppField = ref(null)
    const newPageModal = ref(false)

    const activeAppStep = ref('')
    const activeAppStepObj = ref(null)

    pages.value = Array.from(new Set((modelValue.value.fields as Array<any>).map(field => field.pageNumber.toString())))
    activePage.value = pages.value[0]
    fields.value = (modelValue.value as any).fields.filter(field => field.pageNumber.toString() === activePage.value)

    const updateActiveField = (field) => {
      activeField.value = field
    }

    const lastPage = () => {
      const pages = Array.from(new Set((attrs['v-model'] as AppStepSectionDTO).fields.map(f => f.pageNumber)))
      return Math.max(...pages)
    }

    const addPage = (page: number = null, sortOrder: number = null) => {
      initialAppField.value.pageNumber = page ?? 1
      initialAppField.value.sortOrder = sortOrder ?? 1
      initialAppField.value.new = true;
      (attrs['v-model'] as AppStepSectionDTO).fields.push(initialAppField.value)
      activePage.value = '1'
      initialFieldModal.value = false
      newPageModal.value = false
    }

    const addField = () => {
      newAppField.value.new = true
      newAppField.value.pageNumber = activePage.value
      newAppField.value.sortOrder = (attrs['v-model'] as AppStepSectionDTO).fields.filter(f => f.pageNumber === activePage.value).length;
      (attrs['v-model'] as AppStepSectionDTO).fields.push(newAppField.value)
      addFieldModal.value = false
    }

    const removeField = () => {
      console.log(activeField.value)
      activeField.value.delete = true
      activeField.value = null
    }

    const closeModal = () => {
      initialFieldModal.value = false
    }

    const requestAppFields = getAllAppFields()
    requestAppFields.then((response) => {
      response.data.forEach((elem: any) => {
        elem.label = elem.appFieldName
        elem.value = elem.appFieldId
      })
      allAppFields.value = response.data
    })

    const updateParent = (appStepId) => {
      const targetSectionId = (attrs['v-model'] as AppStepSectionDTO).appStepId
      console.log(targetSectionId)

      //   const prevParent = props.appSteps.find((x: any) => {
      //     console.log(x)
      //     if (x.childrenPlaceholder) {
      //       const children = x.childrenPlaceholder
      //       const hasTarget = children.includes(child => child.appStepId === targetSectionId)
      //       console.log(hasTarget)
      //       if (children) return x
      //     }
      //   }) as AppStepSectionDTO

      const newParent = props.appSteps.find((x: any) => x.appStepId === appStepId) as AppStepSectionDTO

      if (!newParent.childrenPlaceholder) newParent.childrenPlaceholder = []
      newParent.childrenPlaceholder.push((attrs['v-model'] as AppStepSectionDTO))

      //   const indexBol n = array.indexOf(5)
      //   prevParent.childrenPlaceholder.join
      console.log(props.appSteps)
    }

    watch(activePage, (_activePage) => {
      const _fields = (modelValue.value as any).fields.filter(field => field.pageNumber.toString() === _activePage)
      activeField.value = null
      fields.value = _fields
    })

    watch(activeField, (_activeField) => {
      if (!_activeField) return
      (_activeField.relatedFields as Array<unknown>).map((raf: any) => {
        raf.appField = allAppFields.value.find(f => f.appFieldId === raf.appFieldId)
        return raf
      }
      )
    })

    watch(activeAppStep, (_activeAppStep) => {
      activeAppStepObj.value = (attrs['v-model'] as AppStepSectionDTO).childrenPlaceholder[_activeAppStep]
    })

    return {
      modelValue,
      allAppFields,
      updateActiveField,
      activePage,
      activeField,
      fields,
      pages,
      activeAppStep,
      activeAppStepObj,
      addPage,
      initialFieldModal,
      closeModal,
      initialAppField,
      addField,
      newAppField,
      addFieldModal,
      newPageModal,
      lastPage,
      removeField,
      updateParent
    }
  }
})
